module.exports = __webpack_public_path__ + "0.2.26/img/icon_shouye.1f0dfde1.png";